import api from './interceptor';

const BASE_URL_V1 = 'api/v1/pillar-payment';

export default {
  // API Version 1
  getFormURL: params => api.post(`${BASE_URL_V1}/form`, params),
  getFormURLForAddingCard: () => api.get(`${BASE_URL_V1}/form`),
};
